'use strict';
var parent = require('../../stable/iterator/every');
require('../../modules/esnext.iterator.constructor');
require('../../modules/esnext.iterator.every');

module.exports = parent;
